// Inside the Android app, when a newer version is on the website: a slim bar
// to get it. (The pages themselves are always current; only the app's own
// parts — widgets, icon — need installing.)

import { Download, X } from 'lucide-react';
import { APP_APK, useAppUpdate } from '../data/androidApp.ts';

export function AppUpdate() {
  const { latest, dismiss } = useAppUpdate();
  if (!latest) return null;
  return (
    <div className="app-update" role="status">
      <span>
        <strong>App update ready</strong> <span className="muted small">— version {latest}, with the latest widgets. Installs over this one; nothing to set up again.</span>
      </span>
      <a className="btn btn-primary btn-sm" href={APP_APK} download>
        <Download className="btn-icon" aria-hidden />
        <span>Update</span>
      </a>
      <button type="button" className="app-update-close" aria-label="Later" onClick={dismiss}>
        <X aria-hidden />
      </button>
    </div>
  );
}
